

























































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import "moment-timezone";
import moment from "moment";
import FileUpload from "vue-upload-component";
import { FileUploadRequest } from "@/admin/types";

@Component({
  components: {
    FileUpload
  }
})
export default class UploadFileForm extends Vue {
  @Prop([String, Array])
  allowedFileType: string | string[];
  @Prop({ default: false })
  allowsPriorYear: boolean;
  @Prop({ default: false })
  allowsNextYear: boolean;
  @Prop()
  uploadFunction: (request: FileUploadRequest) => Promise<any>;
  @Prop()
  isDisabled: boolean;
  @Prop()
  isUploading: boolean;
  @Prop()
  accept: string;

  fileKey = 0;
  fileName = null;
  effectiveYear = moment().year();

  uploadErrors = [];

  get allowedFileTypeRegex (): string {
    return Array.isArray(this.allowedFileType) ? this.allowedFileType.join("|") : this.allowedFileType;
  }

  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (this.allowedFileType) {
        const regex = new RegExp(`.(${this.allowedFileTypeRegex})$`, "i");
        if (!regex.test(newFile.name)) {
          this.uploadErrors.push("File type not allowed. only " + this.allowedFileType + " type files are allowed");
          this.fileName = null;
          return prevent();
        }
      }
      this.fileName = newFile.name;
    }
  }

  get fileNameDisplay (): string {
    return this.fileName ? this.fileName : "No file selected";
  }

  refreshFileUpload () {
    this.fileName = null;
    this.$parent.$parent.$emit("refreshFileUpload", true);
  }

  uploadFile (files) {
    if (!files) {
      return;
    }

    this.uploadFunction({
      file: (document.getElementById("file") as any).files[0]
    })
    .finally(() => this.refreshFileUpload());
  }

  clearErrors () {
    this.uploadErrors = [];
  }

  get disableUpload () {
    return this.isDisabled;
  }
}
